import { belongsTo } from "@ember-data/model";
import type Patient from "parog-web/models/patient";
import type { TreatmentSectionWithColor } from "./base-treatment-filled-journal-event";
import BaseTreatmentFilledJournalEvent from "./base-treatment-filled-journal-event";

export default class InterTreatmentFilledJournalEvent extends BaseTreatmentFilledJournalEvent {
  static type = "inter-treatment-filled-journal-event";

  @belongsTo("patient", {
    async: false,
    inverse: "interTreatmentFilledJournalEvents"
  })
  declare patient: Patient;

  static sections = this.baseSections;

  get sectionsWithColor(): TreatmentSectionWithColor[] {
    return this.baseSectionsWithColor;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "inter-treatment-filled-journal-event": InterTreatmentFilledJournalEvent;
  }
}
